import React from 'react';
import Box from 'Components/Atoms/Box';
import TextField from 'Components/Atoms/TextField';
import Typography from 'Components/Atoms/Typography';

/** The ticket e-mail's standard text (API: ticketDocument STANDARD_MAIL_TEXT), after „Hallo <Name>,“. */
export const STANDARD_TICKET_MAIL_TEXT =
  'hier ist dein Ticket. Zeige den QR-Code am Einlass vor – auf dem Handy oder ausgedruckt (PDF im Anhang).';

const HELP_ID = 'event-ticket-mail-text-help';

/**
 * The event's own text of the QR-ticket e-mail, directly below the QR-Code switch.
 * Plain text, line breaks are kept; empty uses the standard text. Saved with the
 * event; ticket facts and the QR code are always added by the e-mail itself.
 */
const TicketMailTextField: React.FC<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }) => (
  <Box className="mg-bt-lg" data-testid="event-ticket-mail-text">
    <TextField
      id="event-ticket-mail-text"
      fullWidth
      multiline
      rows={4}
      label="QR ticket e-mail text"
      labelTranslation="calendar"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ maxLength: 2000, 'aria-describedby': HELP_ID }}
    />
    <Typography id={HELP_ID} block color="subdued" variant="text-3" translation="calendar" className="mg-bt-xs">
      Shown above the QR code in the ticket e-mail. Name, date, time, persons, booking code and QR code are always included. Leave empty to use the standard text.
    </Typography>
    <Typography block color="subdued" variant="text-3" translation="calendar">
      Standard text:
    </Typography>
    <Typography block color="subdued" variant="text-3" translation={null}>
      „Hallo &lt;Name&gt;, {STANDARD_TICKET_MAIL_TEXT}“
    </Typography>
  </Box>
);

export default TicketMailTextField;
